import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import InlineNotice from "src/components/InlineNotice"
import Loader from "src/components/Loader"

import { getInvoice } from "src/api/Billing/Payments"

import InvoiceHeader from "./InvoiceHeader"
import InvoicePayments from "./InvoicePayments"

const InvoiceDetail = ({ invoiceId }) => {
  const { marinaSlug } = useMarina()
  const {
    data: invoice,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["invoiceDetail", marinaSlug, invoiceId],
    queryFn: () => getInvoice({ marinaSlug, invoiceId }),
  })

  if (isLoading) return <Loader name="invoice" />
  if (isError)
    return (
      <div className="mx-auto max-w-[860px] px-4 py-6">
        <InlineNotice variant="error">
          We couldn’t load this invoice. Try refreshing the page.
        </InlineNotice>
      </div>
    )

  return (
    <div className="mx-auto flex max-w-[1200px] flex-col gap-6 px-4 pb-6">
      <InvoiceHeader invoice={invoice} />
      <InvoicePayments payments={invoice.payments} />
    </div>
  )
}

InvoiceDetail.propTypes = {
  invoiceId: PropTypes.string.isRequired,
}

export default InvoiceDetail
